import { ModalEditRegsterStyled } from "../../../Modal/ModalEditRegister/styles";
import { Modal } from "../../../Modal";
import { Input } from "../../../../assets/styles/Input";
import { UserContext } from "../../../../providers/UserContext";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { iRegisterData, registerSchema } from "./register.schema";
import { ButtonStyled } from "../../../Button/styles";
import { ModalTerm } from "../../../ModalTerm";
import { TermStyled } from "../ModalTerm/stylesTerm";

type iModalRegister = {
	showRegister: boolean;
	setShowRegister: Dispatch<SetStateAction<boolean>>;
};

export const ModalRegisterHeader = ({
	showRegister,
	setShowRegister,
}: iModalRegister) => {
	const [showModalTerm, SetShowModalTerm] = useState(false);

	const { userRegister } = useContext(UserContext);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<iRegisterData>({
		resolver: zodResolver(registerSchema),
	});

	const submitRegister = (registerData: iRegisterData) => {
		if (registerData.isTermAccepted) {
			userRegister(registerData, setShowRegister);
		} else {
			console.log("Você precisa aceitar os termos e condições de uso")
		}
	};

	return (
		<ModalEditRegsterStyled>
			{showRegister && (
				<Modal showModal={setShowRegister}>
					<div className="card">
						<h1>Cadastro</h1>
						<div className="form">
							<form onSubmit={handleSubmit(submitRegister)}>
								<Input
									type="text"
									id="name"
									placeholder="Nome"
									{...register("name")}
									alt="Nome"
								/>
								{/* {errors.name && <p>{errors.name.message}</p>} */}

								<Input
									type="text"
									id="username"
									placeholder="Username"
									{...register("username")}
									alt="Username"
								/>
								{/* {errors.username && <p>{errors.username.message}</p>} */}
								<Input
									type="text"
									id="bio"
									placeholder="Bio"
									{...register("bio")}
									alt="Bio"
								/>
								{/* {errors.bio && <p>{errors.bio.message}</p>} */}
								<Input
									type="text"
									id="phone"
									placeholder="Telefone"
									{...register("phone")}
									alt="Telefone"
								/>
								{/* {errors.phone && <p>{errors.phone.message}</p>} */}
								<Input
									type="email"
									id="email"
									placeholder="Email"
									{...register("email")}
									alt="Email"
								/>
								{/* {errors.email && <p>{errors.email.message}</p>} */}
								<Input
									type="password"
									id="password"
									placeholder="Senha"
									{...register("password")}
									alt="Senha"
								/>
								{/* {errors.password && <p>{errors.password.message}</p>} */}
								<TermStyled>
									<input
										type="checkbox"
										id="confirm"
										placeholder="confirm"
										autoComplete="on"
										{...register("isTermAccepted")}
										alt="confirm"
									/>
									<label htmlFor="confirm">
										Eu aceito os{" "}
										<button
											className="term-condition"
											type="button"
											onClick={() => {
												SetShowModalTerm(true);
											}}
										>
											Termos e Condições de Uso
										</button>
									</label>
								</TermStyled>
								<ButtonStyled type="submit">Cadastrar</ButtonStyled>
							</form>
						</div>
					</div>
					<ModalTerm
						showModalTerm={showModalTerm}
						setShowModalTerm={SetShowModalTerm}
					/>
				</Modal>
			)}
		</ModalEditRegsterStyled>
	);
};
